module.exports = __webpack_public_path__ + "media/images/icons/lock-3a02a6a60d4e14a9e5e1704dbf2c1c0b.svg";